import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import PostCard from "../components/PostCard";
import api from "../lib/api";
import { BookmarkSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const TRAVEL_ASSET = "https://static.prod-images.emergentagent.com/jobs/7bfd5dde-59f4-4f41-bd29-ac397f2276b1/images/d38fcf11f4778de2d9ac59af0a8d1ac2a339878b84a6716651a0c6e4e5498e38.png";

export default function BookmarksPage() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const { data } = await api.get("/bookmarks");
            setPosts(data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const onUpdate = (updated) => {
        // If user un-bookmarks from this list, remove the card
        if (!updated.is_bookmarked) {
            setPosts((cur) => cur.filter((p) => p.id !== updated.id));
        } else {
            setPosts((cur) => cur.map((p) => (p.id === updated.id ? updated : p)));
        }
    };

    return (
        <div className="min-h-screen bg-[#FAFAFA]" data-testid="bookmarks-page">
            <Navbar />

            <header className="bg-gradient-to-br from-[#990000] to-[#7A0000] relative overflow-hidden">
                <div className="absolute -right-12 -top-12 w-72 h-72 rounded-full bg-[#FFCC00]/10 blur-3xl" />
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14 relative">
                    <div className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFCC00] mb-2">Your Trip Plan</div>
                    <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tighter">
                        Saved posts
                    </h1>
                    <p className="text-white/70 mt-3 max-w-xl">
                        Your private collection of recommendations. Bookmark posts as you browse to build the perfect India trip plan.
                    </p>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                {loading ? (
                    <div className="space-y-4">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div key={`bm-skeleton-${i}`} className="bg-white border border-stone-200 rounded-xl p-6 animate-pulse">
                                <div className="h-3 w-24 bg-stone-200 rounded mb-3" />
                                <div className="h-5 w-3/4 bg-stone-200 rounded mb-3" />
                                <div className="h-3 w-full bg-stone-100 rounded" />
                            </div>
                        ))}
                    </div>
                ) : posts.length === 0 ? (
                    <div className="bg-white border border-stone-200 rounded-xl p-12 text-center">
                        <img src={TRAVEL_ASSET} alt="" className="w-32 h-32 mx-auto mb-6 opacity-90" />
                        <BookmarkSimple size={28} className="mx-auto text-[#990000] mb-2" weight="regular" />
                        <div className="font-heading text-xl font-semibold text-[#0A0A0A] mb-2">No saved posts yet</div>
                        <p className="text-stone-500 mb-5 max-w-sm mx-auto text-sm">
                            Tap the bookmark icon on any post to add it here. Build your private India trip plan as you discover great recs.
                        </p>
                        <Link
                            to="/feed"
                            data-testid="bookmarks-empty-feed-link"
                            className="inline-flex items-center px-5 h-10 rounded-lg bg-[#990000] text-white hover:bg-[#7A0000] text-sm font-medium"
                        >
                            Browse the feed
                        </Link>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {posts.map((p, i) => (
                            <PostCard key={p.id} post={p} onUpdate={onUpdate} index={i} />
                        ))}
                    </div>
                )}
            </main>
        </div>
    );
}
